import React from "react";
import { RCCAlert, RCCButton, RCCGrid,RCCIcon, RCCProgress, RCCTooltip } from "react-common-components";
import { Link } from "react-router-dom";
import AppIcons from "src/components/AppIcons";
import CardSquares from "src/components/DashboardComponents/DefaultDashboardComponents/CardSquares";
import DefaultBody from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultBody";
import DefaultContainer from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultContainer";
import Photo from "src/components/Photo";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import useEffectFetchData from "src/hooks/useEffectFetchData";
import { IProject } from "src/pages/Projects/Project/interface";
import formatDate from "src/utils/formatDate";
import HeaderDashboard from "../../../DefaultDashboardComponents/HeaderDashboard";
import { ICardConfigs } from "../../../interface";
import { Container, Span } from "./styles";

const DashboardCardSpecificProject: React.FC<ICardConfigs> = ({
	card
}) => {
	const { translate, currentLanguage } = useTranslation();
	const {REACT_APP_S3_ADDRESS, REACT_APP_S3_DIRECTORY} = process.env;

	const { data, loading } = card?.daa002Idorigem ?  useEffectFetchData<IProject> (
		"DashboardProjects/SelectProject", 
		{ id: card?.daa002Idorigem }
	): { data: undefined, loading: true };

	return (
		<DefaultContainer>
			<HeaderDashboard 
				description={card?.daa002Descricao}
				title={card && card.daa002Titulo.trim().length > 0 ? card.daa002Titulo : translate("Detalhe Projeto")}
				hexColor={card?.daa002Cor !== null ? card?.daa002Cor : undefined}
				isLoading={loading}
			>
				{card?.daa002Idorigem && (
					<Link to={`/projects/panel/${card.daa002Idorigem}`}>
						<RCCTooltip
							text={translate("Projeto")}
							color="grey"
						>
							<RCCButton 
								color="transparent"
								icon={{
									name: "link",
									color: "var(--app-icons-color)"
								}}
							/>
						</RCCTooltip>
					</Link>
				)}
				<Link to="/projects/panel">
					<RCCTooltip
						text={translate("Painel de Projetos")}
						color="grey"
					>
						<RCCButton
							color="transparent"
						>
							<AppIcons 
								name="projects"
								size={14}
							/>
						</RCCButton>
					</RCCTooltip>
				</Link>
			</HeaderDashboard>


			<DefaultBody>
				{!card?.daa002Idorigem ? (
					<RCCAlert 
						title={translate("Atenção")}
						description={translate("É necessário selecionar um projeto")}
					/>
				) : (
					<>
						{data && (
							<>
								<Title color="purple" marginTop={-8}>
									{data.pra002Titulo}
								</Title>
								
								<RCCGrid container item justifyContent="space-around">
									<CardSquares>
										<RCCProgress 
											layout="circle"
											value={data.completionPercentage || 0}
											color="var(--blue)"
											width="70px"
										/>
										<span className="text"> % {translate("Conclusão")} </span>
									</CardSquares>
									<CardSquares>
										<RCCProgress 
											layout="circle"
											value={data.expectedPercentage || 0}
											color="var(--blue)"
											width="70px"
										/>
										<span className="text"> % {translate("Previsto")} </span>
									</CardSquares>
								</RCCGrid>

								<RCCGrid container item justifyContent="space-around" alignItems="center">
									<Container>
										<Photo 
											name={data.pra002Efa005Nome}
											link={data.pra002Efa005Imagem && `${REACT_APP_S3_ADDRESS}/${REACT_APP_S3_DIRECTORY}/imagens_usuarios/${data.pra002Efa005Imagem}`}
											hover
										/>
										<Span>
											{data.pra002Efa005Nome}
										</Span>
									</Container>
									<Container>
										<RCCIcon name="calendar" size={16} color="var(--default-color-font)" />
										<Span>
											<b>{`${translate("Período")}: `}</b> {formatDate(data.pra002Dtiniest, currentLanguage)} - {formatDate(data.pra002Dtfimest, currentLanguage)}
										</Span>
									</Container>

									<Span>
										<p><b>{`${translate("Ações Concluídas")}: `}</b>{data.completed}/{data.count}</p>
									</Span>
								</RCCGrid>
							</>
						)}
					</>
				)}
			</DefaultBody>
		</DefaultContainer>
	);
};

export default DashboardCardSpecificProject;
